module.exports = __webpack_public_path__ + "static/img/qqq.9d502b2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/logos/qqq.png
// module id = cs4i
// module chunks = 0